import $ from "jquery";
import {Component, h} from "preact";
import {classes} from "mojave/classes";
import {ICON_CHECKBOX, ICON_CHECKBOX_CHECKED, ICON_CHEVRON} from "../lib/icons";


/**
 * @typedef {{
 *      step: number,
 *      activeStep: number,
 *      headline: string,
 *      children: JSX.Element[],
 *      isDeactivated: boolean,
 *      isHeadlineVisible: boolean,
 *      onDirectSelect: ?function(),
 *      onProceed: ?function(),
 * }} Step.Props
 *
 * @typedef {{
 * }} Step.State
 */
export class Step extends Component
{
	/**
	 * @inheritDoc
	 * @param {Step.Props} nextProps
	 */
	componentWillReceiveProps (nextProps)
	{
		/** @type {Step.Props} props */
		const props = this.props;

		const wasActive = props.activeStep === props.step;
		const isActive = nextProps.activeStep === nextProps.step;

		if (wasActive !== isActive)
		{
			let $base = $(this.base);
			const $content = $base.find("._membership-step-content");
			let method;

			// with vertical navigation, use slide down / in
			if (props.isHeadlineVisible)
			{
				method = isActive ? "slideDown" : "slideUp";
			}
			else
			{
				method = isActive ? "show" : "hide";
			}

			$content.stop(true)[method]();

			if (isActive)
			{
				let $scrollTarget;

				if (!props.isHeadlineVisible)
				{
					// with horizontal navigation, just scroll up all the way
					$scrollTarget = $base.closest("._membership");
				}
				else
				{
					$scrollTarget = $base.prev().length === 1
						? $base.prev()
						: $base;
				}

				// scroll to the top of the new step
				$(window).animate({
					scrollTop: $scrollTarget.offset().top - 30,
				});
			}
		}
	}


	/**
	 * @inheritDoc
	 * @param {Step.Props} props
	 * @param {Step.State} state
	 * @returns {JSX.Element}
	 */
	render (props, state)
	{
		const isSelectable = !props.isDeactivated && (props.step < props.activeStep);
		let icon;

		if (props.step < props.activeStep)
		{
			icon = ICON_CHECKBOX_CHECKED;
		}
		else if (props.step === props.activeStep)
		{
			icon = ICON_CHEVRON;
		}
		else
		{
			icon = ICON_CHECKBOX;
		}

		return (
			<div class={classes({
				"_membership-step": true,
				// show first by default, the other ones are shown via transitions
				"_membership-is-active": props.step === 1,
				"_membership-is-selectable": isSelectable,
			})}
			>
				{props.isHeadlineVisible && (
					<div class="_membership-step-headline" onClick={() => this.onHeadlineClick(isSelectable)}>
						<span class="_membership-headline-icon">{icon}</span>
						<span>{`Schritt ${props.step}: ${props.headline}`}</span>
					</div>
				)}
				<div class="_membership-step-content">
					{props.children}
				</div>
			</div>
		);
	}


	/**
	 * @private
	 * @param {boolean} isSelectable
	 */
	onHeadlineClick (isSelectable)
	{
		if (isSelectable && typeof this.props.onDirectSelect === "function")
		{
			this.props.onDirectSelect();
		}
	}
}
